import { NgModule } from '@angular/core';
import { PermissionDirective } from './permission.directive';
import { PermissionAnyDirective } from './permission-any.directive';
import { PermissionAllDirective } from './permission-all.directive';
import { DenyNonNumberTimepickerDirectiveDirective } from './deny-non-number-timepicker-directive.directive';

@NgModule({
  imports: [],
  declarations: [PermissionDirective, PermissionAnyDirective, PermissionAllDirective, DenyNonNumberTimepickerDirectiveDirective],
  exports: [PermissionDirective, PermissionAnyDirective, PermissionAllDirective, DenyNonNumberTimepickerDirectiveDirective]
})
export class DirectivesModule { }
